/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
// @mui material components

// Material Dashboard 2 React components
import MDTypography from "components/MDTypography";
import { useMaterialUIController, setErrorSB } from "context";
import useLocale from "context/useLocale";
import { useState, useEffect } from "react";
import Moment from "react-moment";
import { Link, useParams } from "react-router-dom";

import { fetchAll } from "services/ShowroomCallRequests";

export default function data() {
  const locale = useLocale();
  const { showroomId } = useParams();
  const [_controller, dispatch] = useMaterialUIController();
  const [rows, setRows] = useState([]);
  const [paginationMeta, setPaginationMeta] = useState({});

  const loadData = (page) => {
    fetchAll(showroomId, page).then(
      (res) => {
        setRows(res.data.data.data);
        setPaginationMeta(res.data.data.meta.pagination);
      },
      (err) => setErrorSB(dispatch, `${err.response.data.error.message}`)(err)
    );
  };

  useEffect(() => {
    loadData(1);
  }, []);

  const renderRows = rows.map((row) => ({
    id: row.id,
    name: (
      <MDTypography component="p" variant="button" color="text" fontWeight="medium">
        {row.name}
      </MDTypography>
    ),
    phone: (
      <MDTypography component="p" variant="button" color="text" fontWeight="medium">
        {row.phone}
      </MDTypography>
    ),
    vehicle_id: (
      <MDTypography
        component={Link}
        to={`/dashboard/vehicleEntry/${row.vehicle_entry.vehicle_type_id}/${row.vehicle_entry.vehicle_condition_id}/edit/${row.vehicle_entry.id}`}
        variant=""
        color="text"
        fontWeight="medium"
      >
        {row.vehicle_entry_id}
      </MDTypography>
    ),
    created_at: (
      <MDTypography component="p" variant="button" color="text" fontWeight="medium">
        <Moment format="DD-MMM-YYYY, hh:mm A">{row.created_at}</Moment>
      </MDTypography>
    ),
    updated_at: (
      <MDTypography component="p" variant="button" color="text" fontWeight="medium">
        <Moment format="DD-MMM-YYYY, hh:mm A">{row.updated_at}</Moment>
      </MDTypography>
    ),
  }));

  return {
    columns: [
      { Header: locale("id"), accessor: "id" },
      { Header: locale("name"), accessor: "name" },
      { Header: locale("phone"), accessor: "phone" },
      { Header: locale("vehicle_id"), accessor: "vehicle_id" },
      { Header: locale("createdAt"), accessor: "created_at" },
      { Header: locale("updatedAt"), accessor: "updated_at" },
    ],
    rows: renderRows,
    paginationMeta,
    loadData,
  };
}
